import { useMutation } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { NetworkError, otpVerificationMutationFn } from "../../../../../api";
import { useToast } from "@chakra-ui/react";
import { usePersistStore } from "../../../../../store/persistStore";
import { useNavigate } from "react-router-dom";
import { RoutesMap } from "../../../../../routes.tsx";
import { EPassportFormState } from "../../../../../store/slices/passportFormSliceCreator.ts";
import { PASSPORT_ERROR_MESSAGES } from "../utils";
import { usePassportFormState } from "./usePassportFormState.ts";

const toastId = "passport-mutation";

/**
 * Uses the OTP verification mutation reaction to verify the user's OTP code.
 */
export function usePassportMutationReaction() {
  const toast = useToast();
  const navigate = useNavigate();
  const redirectedRef = useRef(false);
  const passportFormState = usePassportFormState();
  const setJWT = usePersistStore(state => state.setJwt);

  const status = useMutation({
    mutationFn: otpVerificationMutationFn,
  });

  useEffect(() => {
    switch (status.status) {
      case "success": {
        passportFormState.setFormState(EPassportFormState.submitted);
        const response = status.data as { token: string };
        setJWT(response.token);
        return;
      }
      case "error": {
        const error = status.error as NetworkError;
        switch (error.internalCode) {
          // 1100 - invalid code and 7000 too
          case 7000:
          case 1100: {
            passportFormState.setFormState(EPassportFormState.initial);
            return;
          }
          // 4601 - passport required
          case 4601: {
            if (!redirectedRef.current) {
              redirectedRef.current = true;
              passportFormState.setFormState(EPassportFormState.initial);
              passportFormState.setPassportNumber("");
              navigate(RoutesMap.login.passport, { replace: true, state: { reason: "passport_required", from: "login/otp" } });
              // status.reset();
            }
            return;
          }
        }
        // status code is not 456 or unexpected internal code
        toast({
          id: toastId,
          description: PASSPORT_ERROR_MESSAGES.unexpectedServerError,
        });
        passportFormState.setFormState(EPassportFormState.initial);
        return;
      }
    }
  }, [status.status]);

  return status;
}
